import { FC } from 'react';

import { PlaceholderBar } from '../../components/loading-skeleton/index';

type VaultPlaceholderProps = {
  rows?: number;
};

export const VaultPlaceholder: FC<VaultPlaceholderProps> = ({ rows = 7 }) => (
  <div className="flex h-full w-full animate-pulse flex-col gap-4 rounded-md p-1 lg:p-4 lg:shadow-sm">
    {/* Repository / Open Drive tabs */}
    <div className="flex h-[36px] w-full gap-4 border-b border-gray-200">
      <PlaceholderBar className="h-5 w-24 rounded bg-gray-100" />
      <PlaceholderBar className="h-5 w-24 rounded bg-gray-100" />
    </div>

    {/* Breadcrumb + search */}
    <div className="flex w-full items-center justify-between gap-4">
      <PlaceholderBar className="h-5 w-16 rounded bg-gray-100" />
      <PlaceholderBar className="h-10 w-[280px] rounded-lg border border-gray-200 bg-gray-100" />
    </div>

    {/* Files table — mirrors the real <table> column distribution (name, files, last edit, size, actions) */}
    <div className="w-full overflow-x-auto">
      <div className="w-full rounded-md shadow-sm">
        <table className="h-fit w-full divide-y-[1px] divide-[#F2F2F2] border-b-[1px]">
          <thead>
            <tr className="h-11 bg-gray-50">
              <td className="pl-4">
                <PlaceholderBar className="h-4 w-16 rounded bg-gray-100" />
              </td>
              <td className="pl-4">
                <PlaceholderBar className="h-4 w-12 rounded bg-gray-100" />
              </td>
              <td className="pl-4">
                <PlaceholderBar className="h-4 w-20 rounded bg-gray-100" />
              </td>
              <td className="pl-4">
                <PlaceholderBar className="h-4 w-12 rounded bg-gray-100" />
              </td>
              <td className="w-12" />
            </tr>
          </thead>
          <tbody className="divide-y-[1px] divide-[#F2F2F2] bg-white">
            {Array.from({ length: rows }).map((_, index) => (
              <tr className="h-14" key={index}>
                <td className="p-4">
                  <div className="flex items-center gap-2">
                    <PlaceholderBar className="size-8 shrink-0 rounded bg-gray-100" />
                    <PlaceholderBar className="h-4 w-40 rounded bg-gray-100" />
                  </div>
                </td>
                <td className="pl-4">
                  <PlaceholderBar className="h-4 w-8 rounded bg-gray-100" />
                </td>
                <td className="pl-4">
                  <PlaceholderBar className="h-4 w-24 rounded bg-gray-100" />
                </td>
                <td className="pl-4">
                  <PlaceholderBar className="h-4 w-10 rounded bg-gray-100" />
                </td>
                <td className="w-12 pr-4">
                  <PlaceholderBar className="size-5 rounded bg-gray-100" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);
